import { useCallback } from "react";
import { fetcher } from "../../../services/fetcher";
import {
  successNotifications,
  errorNotifications,
} from "../../../utils/handleNotifications";
import { downloadBlob } from "./allPolicyDownload";

export const useAllPolicyHandlers = (currentSelection) => {
  const handleCoversExport = useCallback(async (row) => {
    try {
      const response = await fetcher(
        `issuance/download-cover-documents/?trip_id=${row.id}`,
        "POST",
        null,
        {},
        { responseType: "arraybuffer" }
      );
      if (!response) throw new Error("Export failed");
      downloadBlob(new Blob([response], { type: "application/zip" }), `ASCTrip${row.id}.zip`);
      successNotifications("Covers of trips exported successfully");
    } catch (error) {
      errorNotifications(error.response?.data || "An error occurred", error);
    }
  }, []);

  const handleTripsExport = useCallback(async (row) => {
    try {
      const response = await fetcher("issuance/export/selected-trips/", "POST", {
        trip_ids: row,
      });
      if (!response) throw new Error("Export failed");
      downloadBlob(new Blob([response], { type: "text/csv" }), "exported_trips.csv");
      successNotifications("Trips exported successfully");
    } catch (error) {
      errorNotifications(error.response?.data || "An error occurred", error);
    }
  }, []);

  const handleResendDoc = useCallback(async (row) => {
    try {
      await fetcher("issuance/generate-or-send-document/", "POST", {
        traveller_id: row.id,
      });
      successNotifications("Success! Document resent");
    } catch (error) {
      errorNotifications(error.response?.data?.error || "An error occurred", error);
    }
  }, []);

  const handleDownloadDoc = useCallback(async (row) => {
    const downloadUrl = row.cover_document;
    if (!downloadUrl?.startsWith("https://asc360.s3.amazonaws.com/")) {
      successNotifications("Download URL is not available.");
      return;
    }
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = "CoverDoc";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  const handleTravellersExport = useCallback(async () => {
    if (currentSelection.length === 0) {
      return successNotifications("Please select travellers");
    }
    try {
      const response = await fetcher("issuance/export/selected-travellers/", "POST", {
        traveller_ids: currentSelection,
      });
      if (!response) throw new Error("Export failed");
      downloadBlob(new Blob([response], { type: "text/csv" }), "exported_travellers.csv");
      successNotifications("Travellers exported successfully");
    } catch (error) {
      errorNotifications(error.response?.data || "An error occurred", error);
    }
  }, [currentSelection]);

  return {
    handleCoversExport,
    handleTripsExport,
    handleResendDoc,
    handleDownloadDoc,
    handleTravellersExport,
  };
};
